import { render, staticRenderFns } from "./violationDialogModal.vue?vue&type=template&id=2fe1f854&scoped=true"
import script from "./violationDialogModal.vue?vue&type=script&lang=js"
export * from "./violationDialogModal.vue?vue&type=script&lang=js"
import style0 from "./violationDialogModal.vue?vue&type=style&index=0&id=2fe1f854&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe1f854",
  null
  
)

export default component.exports